import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

const index = r => require.ensure([], () => r(require('../page/index.vue')), 'index');
const index2 = r => require.ensure([], () => r(require('../page/index2.vue')), 'index2');
//星管家登陆注册
const login = r => require.ensure([], () => r(require('../page/login/login.vue')), 'login');
const register = r => require.ensure([], () => r(require('../page/login/register.vue')), 'register');

//台牌进件
const yanzheng = r => require.ensure([], () => r(require('../page/add/yanzheng.vue')), 'yanzheng');
const tijiao = r => require.ensure([], () => r(require('../page/add/tijiao.vue')), 'tijiao');
const saoma = r => require.ensure([], () => r(require('../page/add/saoma.vue')), 'saoma');
const yaoqing = r => require.ensure([], () => r(require('../page/add/yaoqing.vue')), 'yaoqing');

const jinjianOk = r => require.ensure([], () => r(require('../page/add/jinjianOk.vue')), 'jinjianOk');
const newyanzheng = r => require.ensure([], () => r(require('../page/add/newyanzheng.vue')), 'newyanzheng');



//进件状态
const state = r => require.ensure([], () => r(require('../page/state/state.vue')), 'state');
const showCode = r => require.ensure([], () => r(require('../page/state/showCode.vue')), 'showCode');
const skip = r => require.ensure([], () => r(require('../page/state/skip.vue')), 'skip');

const text = r => require.ensure([], () => r(require('../components/text.vue')), 'text');
const pact = r => require.ensure([], () => r(require('../components/pact.vue')), 'pact');
const pact2 = r => require.ensure([], () => r(require('../components/pact2.vue')), 'pact2');

//超级码
const superLogin = r => require.ensure([], () => r(require('../page/supercode/superLogin.vue')), 'superLogin');
const superRegister = r => require.ensure([], () => r(require('../page/supercode/superRegister.vue')), 'superRegister');
const authorization = r => require.ensure([], () => r(require('../page/supercode/authorization.vue')), 'authorization');
const guide = r => require.ensure([], () => r(require('../page/supercode/guide.vue')), 'guide');

const superyanzheng = r => require.ensure([], () => r(require('../page/supercode/superyanzheng.vue')), 'superyanzheng');
const superBusinessyanzheng = r => require.ensure([], () => r(require('../page/supercode/superBusinessyanzheng.vue')), 'superBusinessyanzheng');

const swrong = r => require.ensure([], () => r(require('../page/supercode/swrong.vue')), 'swrong');
const choice = r => require.ensure([], () => r(require('../page/supercode/choice.vue')), 'choice');

// 商户信息登记
const choosePage = r => require.ensure([], () => r(require('../page/merchant/choosePage.vue')), 'choosePage');
const information = r => require.ensure([], () => r(require('../page/merchant/information.vue')), 'information');
const contract = r => require.ensure([], () => r(require('../page/merchant/contract.vue')), 'contract');

// Y计划-小程序进件页面
const yPlanjinjian = r => require.ensure([], () => r(require('../page/yPlan/yPlanjinjian.vue')), 'yPlanjinjian');
const yPlanxw = r => require.ensure([], () => r(require('../page/yPlan/yPlanxw.vue')), 'yPlanxw');
const yPlanFast = r => require.ensure([], () => r(require('../page/yPlan/yPlanFast.vue')), 'yPlanFast');
const demo = r => require.ensure([], () => r(require('../page/yPlan/demo.vue')), 'demo');
const demo2 = r => require.ensure([], () => r(require('../page/yPlan/demo2.vue')), 'demo2');







export default new Router({
    base: '/panasonic/',
    mode: 'history',
    routes: [{
            path: '/',
            name: 'HelloWorld',
            component: HelloWorld
        },
        {
            path: '/index1',
            name: 'index',
            component: index
        },
        {
            path: '/index2',
            name: 'index2',
            component: index2
        },
        {
            path: '/login/login',
            name: 'login',
            component: login
        },
        {
            path: '/login/register',
            name: 'register',
            component: register
        },
        {
            path: '/add/yanzheng',
            name: 'yanzheng',
            component: yanzheng
        },
        {
            path: '/add/tijiao',
            name: 'tijiao',
            component: tijiao
        },
        {
            path: '/add/saoma',
            name: 'saoma',
            component: saoma
        },
        {
            path: '/add/yaoqing',
            name: 'yaoqing',
            component: yaoqing
        },
        {
            path: '/add/jinjianOk',
            name: 'jinjianOk',
            component: jinjianOk
        },
        {
            path: '/state/state',
            name: 'state',
            component: state
        },
        {
            path: '/state/showCode',
            name: 'showCode',
            component: showCode
        },
        {
            path: '/state/skip',
            name: 'skip',
            component: skip
        },
        {
            path: '/text',
            name: 'text',
            component: text
        },
        {
          path: '/pact',
          name: 'pact',
          component: pact
        },
        {
          path: '/pact2',
          name: 'pact2',
          component: pact2
        },
        {
            path: '/add/newyanzheng',
            name: 'newyanzheng',
            component: newyanzheng,
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/supercode/superyanzheng',
            name: 'superyanzheng',
            component: superyanzheng,
            meta: {
                keepAlive: true
            } // false为不缓存
        },
        {
            path: '/supercode/superBusinessyanzheng',
            name: 'superBusinessyanzheng',
            component: superBusinessyanzheng,
            meta: {
                keepAlive: true
            } // false为不缓存
        },
        {
            path: '/supercode/swrong',
            name: 'swrong',
            component: swrong,
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/supercode/superRegister',
            name: 'superRegister',
            component: superRegister
        },
        {
            path: '/supercode/superLogin',
            name: 'superLogin',
            component: superLogin
        },
        {
            path: '/supercode/authorization',
            name: 'authorization',
            component: authorization
        },
        {
            path: '/supercode/guide',
            name: 'guide',
            component: guide,
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/supercode/choice',
            name: 'choice',
            component: choice
        },
        { // 蜻蜓设备
            path: '/merchant/choosePage',
            name: 'choosePage',
            component: choosePage,
            meta: {
                title: '蜻蜓设备'
            }
        },
        { // 商户信息登记
            path: '/merchant/information',
            name: 'information',
            component: information,
            meta: {
                title: '商户信息登记页面',
                keepAlive:true
            }
        },
        { // 电子合同
            path: '/merchant/contract',
            name: 'contract',
            component: contract
        },
        { // Y计划商户进件(企业/个人)
            path: '/yPlan/yPlanjinjian',
            name: 'yPlanjinjian',
            component: yPlanjinjian,
            meta: {
                keepAlive: true
            } // false为不缓存
        },
        { // Y计划商户进件(小微)
            path: '/yPlan/yPlanxw',
            name: 'yPlanxw',
            component: yPlanxw,
            meta: {
                keepAlive: true
            } // false为不缓存
        },
        { // Y计划快速进件
            path: '/yPlan/yPlanFast',
            name: 'yPlanFast',
            component: yPlanFast,
            meta: {
                keepAlive: true
            } // false为不缓存
        },
        { // Y计划商户进件(小微)
            path: '/yPlan/demo',
            name: 'demo',
            component: demo
        },
        { // Y计划商户进件(小微)
            path: '/yPlan/demo2',
            name: 'demo2',
            component: demo2
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js